import styled from "styled-components";
import { Font, Color, breakpoints, ColorDark } from "@/shared/Constants";

export const VideoStory = styled.section.attrs((props) => ({
  className: props.className,
}))`
  .version-videoStory {
    padding: 0;
    margin: 15px 0 20px 0;

    ${breakpoints.mobileFirst} {
      margin: 5px 0 20px 0;
    }
  }

  .title-news {
    max-width: calc(900px + 1.5rem);
    margin: auto;
    padding-bottom: 40px;
    ${breakpoints.mobileFirst} {
      padding-bottom: 30px;
    }

    .video-name {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      span {
        ${Font.clarinVarSub2Regular};
        color: ${Color.mainColor};
        line-height: 48px;
        letter-spacing: -0.42px;
        font-size: 42px;
        ${breakpoints.phone} {
          font-size: 28px;
          line-height: 33px;
          letter-spacing: -0.28px;
        }
      }
    }
  }

  h1 {
    ${Font.clarinVarSub2Bold};
    color: ${Color.black000};
    line-height: 48px;
    letter-spacing: -0.42px;
    font-size: 42px;
    ${breakpoints.phone} {
      font-size: 28px;
      line-height: 33px;
      letter-spacing: -0.28px;
    }
  }
  hr {
    margin: 0;
    border: 0 none;
    &:before {
      content: "";
      height: 1px;
      width: 100%;
      background: #e0e0e0;
      display: block;
      margin: 3px 0;
    }
    &:after {
      content: "";
      height: 1px;
      width: 100%;
      background: #e0e0e0;
      display: block;
      margin-top: 5px;
    }
  }
  .title {
    font-size: 16px;
    ${Font.sansBold};
    color: ${Color.black000};
    margin-top: 3px;
    display: block;
    padding: 1rem 0;
    line-height: 28px;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${ColorDark.textLight};
      }
    }
    ${breakpoints.phone} {
      font-size: 17px;
    }
  }
  .date {
    ${Font.sansRegular};
    font-size: 11px;
    display: flex;
    flex-direction: row;
    color: ${Color.black000};
    white-space: nowrap;
    flex-wrap: wrap;
    line-height: 18px;
  }
  .modificatedDate {
    margin-left: 3px;
    padding-bottom: 0.3rem;
  }
  .createDate {
    padding-bottom: 0.3rem;
  }
  a {
    text-decoration: none;
  }

  .columnContainer {
    column-gap: 1rem;
    display: flex;
    flex-direction: column;
    width: 300px;

    ${breakpoints.phone} {
      width: 100%;
      justify-content: center;
      margin-top: 20px;
    }
    .container {
      position: relative;
      padding-bottom: 1rem;
    }
    .sticky-element {
      position: sticky;
      top: 50px;
      height: 600px;
      margin: 2rem 0 0 0;
      width: 300px;

      ${breakpoints.tablet} {
        top: auto;
      }

      ${breakpoints.phone} {
        display: none;
      }
    }
    .column {
      width: 300px;
      ${breakpoints.tablet} {
        position: relative;
      }

      ${breakpoints.phone} {
        display: flex;
        align-items: center;
        width: 100%;
      }
    }
  }

  .storySummary {
    color: ${Color.grey};
    ${Font.sansRegular};
    font-size: 22px;
    line-height: 36px;
    letter-spacing: -0.22px;
    text-decoration: none;
    ${breakpoints.phone} {
      font-size: 18px;
      line-height: 23px;
      letter-spacing: -0.18px;
      padding-bottom: 13px;
    }
    a {
      color: ${Color.mainColor};
      &:before {
        background: ${Color.mainColor};
        border-radius: 4px;
        content: " ";
        display: inline-block;
        height: 4px;
        width: 4px;
        margin-right: 6px;
        transition-duration: 0.3s;
        vertical-align: middle;
      }
      &:hover {
        color: ${Color.black};
      }
    }
    ul li {
      &:before {
        background: ${Color.grey};
        border-radius: 4px;
        content: " ";
        display: inline-flex;
        height: 4px;
        width: 4px;
        margin-right: 6px;
        transition-duration: 0.3s;
        vertical-align: middle;
      }
    }
  }
`;
